import React, { useEffect } from "react"

import { HalvaFooter } from "@ecom/ui/components/HalvaFooter"
import { HeaderWithBurger } from "@ecom/ui/components/Header/HeaderWithBurger"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import loadable from "@loadable/component"
import LazyHydrate from "react-lazy-hydration"
import { BlackHalvaLogoV2 } from "../components/Headers/Logos"

import Layout, { PageLayoutProps } from "../components/Layouts/mainPage"
import { BannerProps } from "../components/Seo/Banner"
import { Breadcrumbs } from "../components/Breadcrumbs"
import { Banner } from "../components/Banners/Pkw"
import { HowSteps } from "../components/HowSteps"
import { STEPS_ZAIMY } from "../components/HowSteps/helpers"
import { BetterHalva } from "../components/BetterHalva-v2"
import { FormPKW } from "../components/FormPKW"
import { NewCalculator } from "../components/NewCalculator"
import { SwitcherTextBlock } from "../components/SwitcherTextBlock"
import { NewSeoOtherOffers } from "../components/NewSeoOtherOffers"

import zaimyTags from "../static/zaimyTags.json"

import headerLinksV2 from "../data/dataHeader/headerLinksV2.json"
import footerLinksV2 from "../data/dataFooter/footerLinksV2.json"

import { renderLinkList } from "./helpers/renderLinkList"
import { createSeoData } from "./helpers/createSeoData"
import { CardsList } from "../components/CardsList"
import { ZAIMY_CARDS_LIST } from "../components/CardsList/data"
import { handleClickHeader } from "../helpers/WatcherDL/utils/handleClickHeader"
import { DLClickEventExtended } from "../helpers/WatcherDL/DLEvents"

const Reviews = loadable(() => import("../components/Reviews"))

interface Tags {
  name: string
  seos?: {
    shortTitle: string
    url: string
  }[]
}

// Время для таймер(30мин)
const countDownTime = 1800000

const bannerTitle = "Займ онлайн"
const bannerDescription = "Что выгоднее: получить микрозайм или\u00A0карту рассрочки*\u00A0«Халва»?"

const titleHowToGetCard = "Как оформить займ онлайн"
const titleForm = (
  <>
    Оформите карту сейчас – <br /> получите подарок!
  </>
)

type Props = {
  pageContext: {
    url: string
    title: PageLayoutProps["title"]
    shortTitle?: string
    description: PageLayoutProps["description"]
    upperBannerText: BannerProps["html"]
    remoteImage: BannerProps["large"]
    remoteImageMob: BannerProps["mob"]
    betterHalvaTitle?: string
    newCalculatorTitle?: string
    howToGetCardTitle?: string
    cardsListTitle?: string
    switcherTextBlockTitle?: string
    formTitle?: string
    seoBlockText?: string
    shortSeoBlockText: string
    phones?: string[]
    noIndex: boolean
    hasOtherPercents: boolean
    ligal: string
    switcherTitle?: string
    variables: {
      halvaOstatok: {
        value: string
      }
    }
    listing?: {
      items: {
        image: string
        title: string
        description: string
        ctaButton?: string
        ctaButtonTitle?: string
        moreDetails?: string
        moreDetailsTitle?: string
      }[]
    }
  }
}
export default function Seo({ pageContext }: Props) {
  const {
    upperBannerText,
    url,
    title,
    shortTitle,
    description,
    shortSeoBlockText,
    noIndex,
    switcherTitle,
    listing,
    betterHalvaTitle,
    newCalculatorTitle,
    howToGetCardTitle,
    cardsListTitle,
    switcherTextBlockTitle,
  } = pageContext

  const otherOffersTags: Tags[] = zaimyTags
  const otherOffersTitle: string = "Другие предложения по займам"
  const breakpointColumnsObj: any = {
    default: 4,
    1279: 3,
    959: 2,
    599: 1,
  }

  const isLargeScreen = useMediaQuery("(min-width:1279.5px)")

  const linkList = renderLinkList(url, shortTitle)

  const seoData = createSeoData(title, description, upperBannerText, url, shortTitle)

  const cardsListItems = listing?.items[0]?.title ? listing.items : ZAIMY_CARDS_LIST

  // Получение первой страницы на которую зашел
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])

  const onClick = () => {
    DLClickEventExtended({ name: "Логотип", eventAction: "Клик на логотип", placement: "header" })
    window.open("https://halvacard.ru/", "_blank")
  }

  return (
    <Layout noHeader noFooter seoData={seoData} noIndex={noIndex}>
      <HeaderWithBurger
        Logo={BlackHalvaLogoV2}
        onLogoClick={onClick}
        onSidebarBtnClick={() => handleClickHeader("click_cta", "burger_menu")}
        onHeaderBtnClick={() => handleClickHeader("click_cta", "header")}
        orderNum="99"
        listLinksForNav={headerLinksV2}
        anotherStylesTypeV2
        isCountdown
        withButton={isLargeScreen}
      />
      {linkList && <Breadcrumbs linkList={linkList} orderNum="1" />}
      <Banner
        variantStyle="seoZaimy"
        orderNum="2"
        seoHtml={upperBannerText}
        title={bannerTitle}
        description={bannerDescription}
      />
      <LazyHydrate whenVisible>
        <BetterHalva title={betterHalvaTitle && betterHalvaTitle} orderNum="3" />
      </LazyHydrate>
      <LazyHydrate whenVisible={{ rootMargin: "1000px" }}>
        <NewCalculator title={newCalculatorTitle && newCalculatorTitle} orderNum="5" />
      </LazyHydrate>
      <LazyHydrate whenVisible>
        <HowSteps title={howToGetCardTitle || titleHowToGetCard} items={STEPS_ZAIMY} orderNum="6" />
      </LazyHydrate>
      <LazyHydrate whenIdle>
        <FormPKW
          progressBar
          dataLayerName="shortPersonalForm"
          title={titleForm}
          longTitle
          countDownTime={countDownTime}
          withTimer
          formBtnText="Оформить карту"
          orderNum="4"
          isGreenApprove
          hasESIA
        />
      </LazyHydrate>
      <LazyHydrate whenVisible>
        <CardsList
          orderNum="8"
          dataContent={cardsListItems}
          headTitle={cardsListTitle || "Сравните сами займ с картой рассрочки* «Халва»"}
          url={url}
          variantStylesSingleCard="zaimy"
        />
      </LazyHydrate>
      <LazyHydrate whenVisible>
        <SwitcherTextBlock
          title={switcherTextBlockTitle || switcherTitle}
          mode="zaimy"
          seoBlockText={shortSeoBlockText}
          orderNum="9"
          withTableDescription
        />
      </LazyHydrate>
      <Reviews orderNum="10" />
      {otherOffersTags && (
        <NewSeoOtherOffers
          pageUrl={url}
          title={otherOffersTitle}
          tags={otherOffersTags}
          breakpointColumnsObj={breakpointColumnsObj}
          orderNum="11"
        />
      )}
      <LazyHydrate whenVisible>
        <HalvaFooter listLinksForFooter={footerLinksV2} />
      </LazyHydrate>
    </Layout>
  )
}
